export const getInvitationDetails = (service, invitation_token) => {
  return service.post(`/life_time_subscription/link_info`, {
    ml: invitation_token
  });
};

export const processInvitation = (service, invitation_token) => {
  return service.post("/life_time_subscription/claim_membership", {
    ml: invitation_token
  });
};
